import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { ListarVinculoProdutoService } from './listar-vinculo-produto.service';
import { NotificationsService } from 'angular2-notifications';
import { EncriptyUtilService } from '../../../../../shared/services/encripty-util.service';
import { DatatableService } from '../../../../../shared/services/datatable.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { StringUtils } from '../../../../../shared/utils/StringUtils';
import { CommonService } from '../../../../../shared/services/commom.service';

@Component({
  selector: 'ngx-listar-vinculo-produto',
  templateUrl: './listar-vinculo-produto.component.html',
  styleUrls: ['./listar-vinculo-produto.component.scss']
})
export class ListarVinculoProdutoComponent implements OnInit {

  public listaProduto = null;
  public formListaUserProduto = null;
  public funcProd = null;
  rowData: any;
  isProdutoMigrado: boolean = false;

  @ViewChild('myTable', null)
  private myTable: DatatableComponent;
  public customLogin = null;

  constructor(
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private service: ListarVinculoProdutoService,
    private notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private datatableService: DatatableService,
    private spinnerService: NgxSpinnerService,
  ) {

    this.listaProduto = [

      {
        produto: 'POSSUI CONVENIO',
        produtoDescricao: 'POSSUI CONVENIO'
      },

      {
        produto: 'POSSUI SALARIO',
        produtoDescricao: 'POSSUI SALÁRIO'
      },

      {
        produto: 'NAO POSSUI CONVENIO',
        produtoDescricao: 'NÃO POSSUI CONVENIO'
      },

      {
        produto: 'NAO POSSUI SALARIO',
        produtoDescricao: 'NÃO POSSUI SALÁRIO'
      },

    ];

    this.formListaUserProduto = this.formBuilder.group({
      id: [null],
      cpf: [null],
      nome: [null],
      produto: [null]
    });

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);
    this.verificarMigracaoRollout();
  }

  gotoCadastrar(data) {

    let funcionarioNome = this.encriptyService.encriptyBySecretKey('' + data.funcionarioNome);
    let funcionarioCpf = this.encriptyService.encriptyBySecretKey('' + data.funcionarioCpf);
    let status = this.encriptyService.encriptyBySecretKey('' + data.status);
    let funcionarioId = this.encriptyService.encriptyBySecretKey('' + data.funcionarioId);

    let params = {
      'funcionarioNome': funcionarioNome,
      'funcionarioCpf': funcionarioCpf,
      'status': status,
      'funcionarioId': funcionarioId
    }

    this.router.navigate(['/pages/gestao-funcionarios/cadastro-vincular-produto'], { relativeTo: this.activatedRoute, queryParams: params });

  }

  buscarProduto(data) {

    let params = new HttpParams();

    if (!StringUtils.isEmpty(data.cpf)) {

      params = params.append('cpf', data.cpf);

    }

    if (!StringUtils.isEmpty(data.nome)) {

      params = params.append('nome', data.nome);
    }

    if (StringUtils.isEmpty(data.cpf) && StringUtils.isEmpty(data.nome)) {

      this.notificationService.error('Informar CPF ou Nome do Funcionário Cadastrado');

    } else {
      this.spinnerService.show();
      this.service.buscaFuncionarios(params, (response => {

        if (response.content.length == '0') {
          this.spinnerService.hide();
          this.notificationService.error('Não existe Funcionário Cadastrado ou CPF Inválido');
          return;
        }

        this.rowData = response.content;
        this.rowData = this.rowData.map(data => {
          return {
            funcionarioNome: data.pessoa.nome,
            funcionarioCpf: data.pessoa.cpf,
            produtoDescricao: data.produtoDescricao,
            status: data.funcionario.status,
            funcionarioId: data.funcionario.id,

          };
        });
        this.spinnerService.hide();

      }), (error) => {
        this.notificationService.error(error.message);
        this.spinnerService.hide();
      });

    }
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  private verificarMigracaoRollout() {
    this.commonService.isProdutoMigrado().subscribe(isMigrated => {
      this.isProdutoMigrado = isMigrated;
    });
  }

}
